import React from 'react'

// Shared by the alerts table, its details modal and the business error catalog. The modal applies
// its own inline colour override, so the class helper is exported alongside the component rather
// than hidden behind it. `debug` and the fallback stay: ROBO-1323 renders raw alert levels, which
// are not limited to the four the catalog uses.
export const getLevelBadgeClass = (level: string): string => {
  switch (level) {
    case 'debug': return 'badge bg-secondary'
    case 'info': return 'badge bg-primary'
    case 'warning': return 'badge bg-warning text-dark'
    case 'error': return 'badge bg-danger'
    case 'fatal': return 'badge bg-dark'
    default: return 'badge bg-secondary'
  }
}

interface LevelBadgeProps {
  level: string
}

const LevelBadge = ({ level }: LevelBadgeProps) => (
  <span className={getLevelBadgeClass(level)}>{level?.toUpperCase()}</span>
)

export default LevelBadge
